import request from '@/utils/request'

export function getTodo (params) {
  return request({
    url: `/hy/wf/task/wait`,
    method: 'get',
    params
  })
}

export function getDone (params) {
  return request({
    url: `/hy/wf/task/done`,
    method: 'get',
    params
  })
}

// 检查瀚洋之音后六个菜单权限
export function checkMenu (params) {
  return request({
    url: `/hy/sound/special/check`,
    method: 'get',
    params
  })
}

// 检查瀚洋之音前六个菜单权限
export function checkHyzyMenu (params) {
  return request({
    // 测试
    // url: `http://58.34.191.202:8000/wechat/outside/perms?token=` + JSON.parse(localStorage.getItem('Authorization')).val,
    // 生产
    url: `https://app.hanyangtelecom.com/wechat/outside/perms?token=` + JSON.parse(localStorage.getItem('Authorization')).val,
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/home.js